import { getRuntimeValue } from "@3sc/common-component";

const state = {};
const listeners = new Set();

export const setAppRuntimeContext = (partial = {}) => {
  Object.assign(state, partial);
  listeners.forEach((listener) => listener());
};

export const readAppValue = (key) => {
  const value = state[key];
  if (value !== null && value !== undefined) return value;
  const shared = getRuntimeValue(key);
  if (shared !== null && shared !== undefined) return shared;
  return null;
};

export const subscribeRuntimeContext = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
